module.exports = __webpack_public_path__ + "static/media/6.ea70dc2a.jpg";